import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Button, Text, Img } from "../../components";
import Footer from "../../components/Footer";
import HomeColumnBetter from "../../components/HomeColumnBetter";
import Banner from './Banner'
import Ellise from '../../assets/images/Ellipse 1.png'
import Imgage from '../../assets/images/img.png'
import Header from "./Header";
import CardImg from '../../assets/images/SalesImg.png'
import Squareimg from '../../assets/images/Square.svg'
import './style.css'
import Popup from '../popup/Popup'
import CustomerCare from './customer-service.png'
import MapRoute from './responsibility.png'
import WhatsapIcon from './payment-gateway.png'
import ICon from './fast.png'
import ISD from '../../assets/images/Square Transfer Vertical.png'
import Selectlocation from '../../assets/images/Paymnet.png'
import { useNavigate } from "react-router-dom";
import PartnerCard from "./PartnerCard";

export default function BecomeAPartner() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const navigation = useNavigate();

  const togglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  
  return (
    <>
      <Helmet>
        <title>Become a Partner - Washta</title>
        <meta name="description" content="Join Washta as a partner and grow your business" />
      </Helmet>

      {/* home main section */}
      <div className="w-full bg-white-A700" style={{ position: 'relative' }}>
        <Header btnText="Sign Up" btnLink={() => navigation("/become-a-seller")} />

        <div className="flex flex-col items-end">
          {/* hero image section */}
          <Img src={Ellise} alt="image" object className="h-[200px]w-[100%] object-contain" style={{ position: 'absolute', width: '70%' }} />
          <div className="relative flex flex-col items-center gap-[50px] self-stretch md:gap-[93px] sm:gap-[62px]">
            <Banner TextBtn="Sign up" Paragraph="Washta is here to utilize car wash experts at UAE's parking lots. Sign up today and be one of the first to register your carwash service on our platform. We provide you automated booking requests, online payment and simplified sales tracking. "  mainHeading="Grow your business with Washta"togglePopup={() => navigation("/become-a-seller")} />

            <div className="container-xs flex flex-col items-center gap-[86px] md:gap-16 md:p-5 sm:gap-[43px] mb-[10em] md:mb-[5em]">
              {/* features section */}
              <div className="flex w-[94%] flex-col items-center gap-[10px] px-[7px] pt-[7px] md:w-full md:gap-[75px] sm:gap-[50px]">
                <Text size="xl" as="p" className="text-center !font-generalsans !text-black-900">
                Why join Washta
                </Text>
                {/* <Text size="large" as="p" className="w-[55%] text-center !text-black-900_bf md:w-full" style={{ paddingTop: '20px' }}>
                Join the Washta community today and gain access to convenient car wash solutions tailored to your needs. Click on subscribe button below and fill out the short form below to get started.
                </Text> */}
              </div>
              {/* <CardBtn /> */}
              <PartnerCard/>
              <div className="card-name-btn">
                <div className="flex gap-[35px] self-stretch md:flex-col w-[91%] m-auto">
                  <div className="flex w-full flex-col gap-[35px]">
                    {[...Array(1)].map((d, index) => (
                      <HomeColumnBetter
                        image={Selectlocation}
                        text="Online Payment"
                        text1="Secure, fast, and hassle-free in-app payment. Customers pay through the app, so you can say goodbye to handling cash and focus on delivering great service."
                        key={"listbetter" + index}
                        className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
                      />
                    ))}
                    <HomeColumnBetter
                      image={CardImg}
                      text="Sales Tracking"
                      text1="Monitor your daily earnings and team performance in real-time. Stay on top of your business with full visibility into every completed wash."
                      key={"listbetter"}
                      className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
                    />
                  </div>
                  <div className="relative w-full rounded-[26px] border border-solid border-black-900_26 bg-indigo-300 bg-[url(/public/images/img_frame_1171276568.png)] bg-cover bg-no-repeat px-[41px] md:px-5 md:pt-5">
                    <div className="absolute left-0 right-0 m-auto h-full md:h-auto">
                      <Img src={Imgage} alt="main" className="h-full w-full object-cover" style={{ borderRadius: '27px' }} />
                    </div>
                  </div>
                  <div className="flex w-full flex-col gap-[35px]">
                    {[...Array(1)].map((d, index) => (
                      <HomeColumnBetter
                        image={Squareimg}
                        text="Business Insights"
                        text1="Access valuable data and reports to understand customer trends, peak times, and service performance—helping you make smarter business decisions."
                        key={"listautomated" + index}
                        className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
                      />
                    ))}
                    <HomeColumnBetter
                      image={ISD}
                      text="Automated Requests"
                      text1="No more chasing customers or waiting around. Get instant notifications for carwash bookings directly from the app on mobile and desktop."
                      key={"listbetter"}
                      className="flex flex-1 flex-col items-start justify-center rounded-[26px] border border-solid border-black-900_7f p-[25px] sm:p-5"
                    />
                  </div>
                </div>
              </div>
              {/* <Button onClick={togglePopup} shape="round" className="min-w-[150px] sm:px-1" style={{ fontSize: '15px' }}>
                Notify me
              </Button> */}
            </div>
         
           
            {/* Footer Section */}
            <Footer className="flex items-center justify-center self-stretch bg-indigo-300 py-[46px] md:py-5" />
          </div>
        </div>
      </div>
    </>
  );
}
